import React, { Component } from "react";
import Table from "./common/table";
import Timer from "./common/timer";
import Download from "../Images/Download-32.png";
import Agreement from "../Images/Agreement-32.png";
import Copy from "../Images/copy.png";
import Edit from "../Images/Edit-32.png";
import LinkButton from "./common/linkButton";
import DropDownAction from "./common/dropDownAction";
import "./Form/proposalForm.css";
import { getCurrentUser } from "aws-amplify/auth";
import {
  isIspOnlyProgram,
  hasIspOnlyFusionSubStrategy,
} from "../utils/proposalUtils";
import { getIspRequestTypeLabel } from "../utils/ispRequestType";

export const ISP_GENERATION_ETA_SECONDS = 15;
export const PROPOSAL_GENERATION_ETA_SECONDS = 15;

export const formatSubmissionDateTime = (value) => {
  if (!value) return "";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? String(value) : parsed.toLocaleString();
};

export const getIspRemainingSeconds = (creationTime, nowMs = Date.now()) => {
  const created = Number.parseInt(creationTime, 10);
  if (!Number.isFinite(created) || created <= 0) return ISP_GENERATION_ETA_SECONDS;
  const nowSeconds = Math.floor(nowMs / 1000);
  const elapsed = Math.max(0, nowSeconds - created);
  return Math.max(0, ISP_GENERATION_ETA_SECONDS - elapsed);
};

export class ProposalTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TimmerSeconds: 1,
      ispTimerSeconds: {},
      currentUser: "",
      progress: {},
    };
  }

  componentDidMount = async () => {
    let currentUser = await getCurrentUser().catch((e) => {
      // User not authenticated - this is expected
      return null;
    });
    if (currentUser) {
      this.setState({ currentUser: currentUser.username });
    }
  };

  bondObject = { path: "REGISTRATION", label: "Registration" };
  excelObject = {
    label: "Bond - Risk",
    key: "bond-risk",
    content: (proposal) => {
      const bond = proposal["BOND"] || "";
      const embeddedExcel = proposal["embedded-excel"];
      const riskTolerance = proposal["RISK TOLERANCE"];
      const risk = proposal["RISK"];

      // Priority fallback: embedded-excel > RISK TOLERANCE > RISK > blank
      let secondValue = "";
      if (embeddedExcel != null && embeddedExcel !== "") {
        secondValue = embeddedExcel;
      } else if (riskTolerance != null && riskTolerance !== "") {
        secondValue = riskTolerance;
      } else if (risk != null && risk !== "") {
        secondValue = risk;
      }

      return `${bond} ${secondValue}`.trim();
    },
  };
  incomeNeedsObject = { path: "INCOME", label: "Income Needs" };
  userNameObject = { path: "UserName", label: "User Name" };
  advisorName = { path: "ADVISOR NAME", label: "Advisor Name(s)" };
  columns = [
    {
      label: () => (
        <div style={{ height: "22px", width: "22px" }}>
          <input
            onChange={(e) => this.props.handleToggleSelectAll(e)}
            className="form-check-input"
            type="checkbox"
            name="checkbox"
            id="checkboxAll"
            checked={this.props.selectAll === 1 || ""}
            style={{
              margin: "0 0 0 0",
              height: "20px",
              width: "20px",
              position: "top -30px",
            }}
            disabled={this.props.deleteAllInProgress}
          />
        </div>
      ),
      key: "checkbox",
      content: (proposal) => (
        <div style={{ height: "22px", width: "22px" }}>
          <input
            disabled={this.props.deleteAllInProgress || proposal["Download"] !== "true"}
            onChange={(e) => this.props.handleToggleRow(proposal, e)}
            className="form-check-input"
            type="checkbox"
            name="checkbox"
            id={`checkbox_${
              proposal.FileName
                ? proposal.FileName.replace(".pdf", "")
                : `${proposal["CLIENT NAMES"]}_${proposal["DateTime"]}`
            }`}
            checked={
              this.props.selected[
                `${proposal["CLIENT NAMES"]}_${proposal["DateTime"]}`
              ] || ""
            }
            style={{ margin: "auto", height: "20px", width: "20px" }}
          />
        </div>
      ),
    },
    {
      path: "CLIENT NAMES",
      label: "Client Name(s)",
    },
    { path: "program", label: "Strategy" },
    {
      path: "ispRequestLabel",
      label: "Request Type",
      content: getIspRequestTypeLabel,
      headerStyle: { minWidth: "118px" },
      cellStyle: { minWidth: "118px", whiteSpace: "normal" },
    },
    { path: "VALUE", label: "Asset Value" },
    {
      path: "DateTime",
      label: "Date - Time",
      content: (proposal) => formatSubmissionDateTime(proposal.DateTime),
    },
    {
      label: "Downloads",
      key: "downloads",
      headerStyle: { width: "108px", minWidth: "108px" },
      cellStyle: { width: "108px", minWidth: "108px" },
      content: (proposal) => {
        const isISP = proposal.submissionType === "ISP";
        // Detect merged rows — either field indicates both ISP and Proposal exist on the same row.
        // ispFileName is set when a Proposal merges onto an ISP (ISP file info preserved).
        // proposalFileName is set when an ISP merges onto a Proposal (Proposal file info preserved).
        const isMerged = !!proposal.ispFileName || !!proposal.proposalFileName;
        const hasISP = isISP || isMerged;
        const hasProposal = !isISP || isMerged;

        // Resolve download state for a document type.
        // When a merge occurs, the "other" doc's file info is saved in {docType}FileName/{docType}Download.
        // If those fields exist, use them; otherwise the file is in the main FileName/Download fields.
        const getDocDownloadState = (docType) => {
          const altFileName = proposal[`${docType}FileName`];
          const altDownload = proposal[`${docType}Download`];
          if (altFileName) {
            return { ready: altDownload === "true", status: altDownload, fileType: docType };
          }
          return { ready: proposal["Download"] === "true", status: proposal["Download"], fileType: "" };
        };

        const ispDoc = getDocDownloadState("isp");
        const proposalDoc = getDocDownloadState("proposal");
        const paperworkReady =
          (hasISP && ispDoc.ready) || (hasProposal && proposalDoc.ready);
        const progressId = proposal["CLIENT NAMES"] + proposal["DateTime"];

        return (
        <div className="submissions-download-cell">
          <div className="row" style={{ margin: "auto" }}>
            <DropDownAction
              customStyle={{
                width: "100%",
                height: "35px",
                padding: "3px",
                backgroundColor: hasISP && !hasProposal ? "#FF6A42" : "#385EA4",
                color: "white",
                outline: "none",
                border: "none",
              }}
              style={{
                outline: "none",
                border: "none",
                margin: "auto",
                width: "100%",
                borderColor: "white",
              }}
              title={
                <div style={{ paddingBottom: "2px" }}>
                  {this.state.progress[progressId] ? (
                    <div
                      style={{ display: "inline-block", marginRight: "5px" }}
                    >
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </div>
                  ) : null}
                  {hasISP && hasProposal ? "Downloads" : isISP ? "ISP" : "Proposal"}{" "}
                  <span style={{ margin: "auto", fontSize: "10px" }}>
                    &#9660;
                  </span>
                </div>
              }
              ulStyle={{
                padding: "0",
              }}
              drop="dropdown"
              items={[
                // --- ISP Download / Create ---
                hasISP ? (
                  <button
                    title={ispDoc.ready ? "Download ISP Document" : "ISP document not ready yet"}
                    style={{ margin: "auto", padding: "4px 2px", backgroundColor: "#FF6A42", color: "white", borderColor: "white" }}
                    disabled={!ispDoc.ready}
                    onClick={() => {
                      const onClickThis = this;
                      this.addProgress(proposal);
                      this.props.onDownload(proposal, function (x) {
                        onClickThis.setState((prev) => ({ progress: { ...prev.progress, [progressId]: x } }));
                        if (x >= 100) onClickThis.removeProgress(proposal);
                      }, "isp");
                    }}
                    className="col btn"
                  >
                    {ispDoc.ready ? (
                      this.state.progress[progressId] ? (
                        <React.Fragment>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          <span style={{ marginLeft: "10px" }}>Downloading</span>
                        </React.Fragment>
                      ) : (
                        <span><img src={Download} alt="Download ISP" style={{ height: "20px" }} /> Download ISP</span>
                      )
                    ) : (() => {
                      const initialRemaining = getIspRemainingSeconds(proposal.CreationTime);
                      const timerId = `${progressId}-isp-${proposal.CreationTime || "unknown"}`;
                      const trackedRemaining = this.state.ispTimerSeconds[timerId];
                      const remaining = Number.isFinite(trackedRemaining)
                        ? Math.min(initialRemaining, Math.max(0, trackedRemaining))
                        : initialRemaining;
                      return (
                        <label style={{ margin: "0", minWidth: "20px" }}>
                          {initialRemaining > 0 ? (
                            <Timer
                              getTimmerProgress={(seconds) =>
                                this.setState((previousState) => ({
                                  ispTimerSeconds: {
                                    ...previousState.ispTimerSeconds,
                                    [timerId]: Math.max(0, seconds),
                                  },
                                }))
                              }
                              seconds={initialRemaining}
                            />
                          ) : null}
                          {remaining > 0 ? (
                            <span style={{ marginLeft: "4px" }}>(ISP ETA)</span>
                          ) : (
                            <span>Click Refresh Above</span>
                          )}
                        </label>
                      );
                    })()}
                  </button>
                ) : (
                  this.props.onCreateISPFromProposal ? (
                    <button
                      title={!proposalDoc.ready ? "Proposal is still processing" : "Create an Investment Strategy Plan and Fee Disclosure (ISP) from this proposal data"}
                      style={{ height: "100%", width: "100%", backgroundColor: "#28a745", color: "white", borderColor: "white" }}
                      disabled={!proposalDoc.ready}
                      onClick={() => this.props.onCreateISPFromProposal(proposal)}
                      className="col btn btn-sm"
                    >
                      <span><img src={Agreement} alt="Create ISP" style={{ height: "20px" }} /> Create ISP</span>
                    </button>
                  ) : null
                ),
                // --- ISP Edit ---
                hasISP && this.props.onEditISP ? (
                  <button
                    type="button"
                    title={ispDoc.ready ? "Edit this ISP submission" : "ISP document is still processing"}
                    disabled={!ispDoc.ready || !proposal.ispFormData || !proposal.DateTime}
                    onClick={() => this.props.onEditISP(proposal)}
                    style={{ height: "100%", width: "100%", backgroundColor: "#c4512c", color: "white", borderColor: "white" }}
                    className="col btn btn-sm"
                  >
                    <span><img src={Edit} alt="Edit ISP" style={{ height: "20px" }} /> Edit ISP</span>
                  </button>
                ) : null,
                // --- ISP Copy ---
                hasISP && this.props.onEditISP ? (
                  <LinkButton
                    to="/plan/step-guide"
                    type="button"
                    title="Copy ISP"
                    disabled={!proposal.ispFormData}
                    onClick={() => {
                      if (proposal.ispFormData) {
                        sessionStorage.removeItem("editISPDateTime");
                        sessionStorage.setItem("editISPData", proposal.ispFormData);
                      }
                    }}
                    style={{ height: "100%", width: "100%", backgroundColor: "#FF6A42", color: "white", borderColor: "white" }}
                    className="col btn btn-sm"
                  >
                    <span><img src={Copy} alt="Copy ISP" style={{ height: "20px" }} /> Copy ISP</span>
                  </LinkButton>
                ) : null,
                // --- Proposal Download / Create ---
                hasProposal ? (
                  <button
                    title={proposalDoc.status !== "true"
                      ? proposalDoc.status === "false" ? "download failed" : "Download May Not Be Ready"
                      : "Download Proposal"}
                    style={{ margin: "auto", padding: "4px 2px", backgroundColor: "#385EA4", color: "white", borderColor: "white" }}
                    disabled={!proposalDoc.ready}
                    onClick={() => {
                      if (proposalDoc.status === "false") {
                        alert("Try refreshing the page or waiting 10 minutes to try again. An alert has already been sent to us.");
                      } else {
                        if (new Date(String(proposal["DateTime"])).getTime() < new Date().getTime() - 30 * 24 * 60 * 60 * 1000) {
                          alert("This proposal is more than 30 days old. We recommend you run a new one to get the most up to date information.");
                        }
                        const onClickThis = this;
                        this.addProgress(proposal);
                        this.props.onDownload(proposal, function (x) {
                          onClickThis.setState((prev) => ({ progress: { ...prev.progress, [progressId]: x } }));
                          if (x >= 100) onClickThis.removeProgress(proposal);
                        }, "proposal");
                      }
                    }}
                    className="col btn"
                  >
                    {proposalDoc.ready ? (
                      this.state.progress[progressId] ? (
                        <React.Fragment>
                          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                          <span style={{ marginLeft: "10px" }}>Downloading</span>
                        </React.Fragment>
                      ) : (
                        <span><img src={Download} alt="Download" style={{ height: "20px" }} /> Download Proposal</span>
                      )
                    ) : proposalDoc.status !== "false" ? (
                      <label style={{ margin: "0", minWidth: "20px" }}>
                        <Timer getTimmerProgress={(s) => this.setState({ TimmerSeconds: s })}
                          seconds={(() => {
                            const isFusion = proposal.program && proposal.program.toString().toLowerCase().includes("fusion");
                            const eta = isFusion
                              ? 90
                              : PROPOSAL_GENERATION_ETA_SECONDS;
                            if (proposal["DateTime"]) {
                              const diffSeconds = Math.abs((new Date(String(proposal["DateTime"])) - new Date()) / 1000);
                              if (diffSeconds < eta) return Math.round(eta - diffSeconds);
                              return eta;
                            }
                            return eta;
                          })()}
                        />
                        {this.state.TimmerSeconds > 0 ? <span style={{ marginLeft: "4px" }}>(Download ETA)</span> : <span>Click Refresh Above</span>}
                      </label>
                    ) : (
                      <label style={{ margin: "0", minWidth: "20px" }}>Failed. Try again in 10-15 minutes.</label>
                    )}
                  </button>
                ) : (
                  (() => {
                    const ispOnly =
                      isIspOnlyProgram(
                        proposal.program,
                        this.props.proposalTypes
                      ) ||
                      hasIspOnlyFusionSubStrategy(
                        proposal,
                        this.props.proposalTypes
                      );
                    return (
                      <button
                        title={
                          ispOnly
                            ? "This ISP contains an ISP-only strategy and cannot be used to create a proposal — a custom proposal is required"
                            : !ispDoc.ready
                            ? "ISP is still processing"
                            : "Create a proposal from this ISP data"
                        }
                        style={{ height: "100%", width: "100%", backgroundColor: "#385EA4", color: "white", borderColor: "white" }}
                        disabled={!ispDoc.ready || ispOnly}
                        onClick={() => {
                          if (ispOnly) return;
                          if (this.props.onCreateProposalFromISP) this.props.onCreateProposalFromISP(proposal);
                        }}
                        className="col btn btn-sm"
                      >
                        <span><img src={Agreement} alt="Create Proposal" style={{ height: "20px" }} /> Create Proposal</span>
                      </button>
                    );
                  })()
                ),
                // --- Paperwork after either document has completed ---
                <LinkButton
                  to={{ pathname: "/paperwork", state: { proposal: proposal } }}
                  title="Paperwork"
                  disabled={!paperworkReady}
                  style={{ height: "100%", width: "100%", backgroundColor: "#368fff", color: "white", borderColor: "white" }}
                  onClick={() => null}
                  className="col btn btn-sm"
                >
                  <span><img src={Agreement} alt="Paperwork" style={{ height: "20px" }} /> Paperwork</span>
                </LinkButton>,
              ].filter(Boolean)}
            />
          </div>
        </div>
        );
      },
    },
  ];

  // renderISPButtons removed — unified into main content function above
  filterColumns = [];
  timer = 0;
  state = { time: {}, progress: {} };

  addProgress = (proposal) => {
    const id = proposal["CLIENT NAMES"] + proposal["DateTime"];
    this.setState((previousState) => {
      return {
        progress: { ...previousState.progress, [id]: 1 },
      };
    });
  };

  removeProgress = (proposal) => {
    const id = proposal["CLIENT NAMES"] + proposal["DateTime"];
    let currentProgressState = this.state.progress;
    delete currentProgressState[id];
    this.setState({ progress: currentProgressState });
  };

  render() {
    const { proposals, onSort, sortColumn } = this.props;
    if (
      this.props.showDetails &&
      !this.columns.includes(this.bondObject) &&
      !this.columns.includes(this.excelObject)
    ) {
      this.columns.splice(1, 0, this.userNameObject);
      this.columns.splice(2, 0, this.advisorName);
      this.columns.splice(3, 0, this.bondObject);
      this.columns.splice(4, 0, this.excelObject);
    } else if (
      !this.props.showDetails &&
      this.columns.includes(this.bondObject) &&
      this.columns.includes(this.excelObject)
    ) {
      this.columns.splice(this.columns.indexOf(this.userNameObject), 1);
      this.columns.splice(this.columns.indexOf(this.advisorName), 1);
      this.columns.splice(this.columns.indexOf(this.bondObject), 1);
      this.columns.splice(this.columns.indexOf(this.excelObject), 1);
    }

    return (
      <div>
        <Table
          updateColumnList={this.props.updateColumnList}
          columns={this.columns}
          data={proposals}
          sortColumn={sortColumn}
          onSort={onSort}
        />
      </div>
    );
  }
}

export default ProposalTable;
